import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import First from "./First_section/First";
import Second from "./Second_section/Second";
import Third from "./Third_section/Third";
import Fourth from "./Fourth_section/Fourth";
import CareersSection from "../../WhoweAre/ContectUs/CareersSection";

const ECom = () => {
  return (
    <>
      <Header />
      <First />
      <Second />
      <Third />
      <Fourth />
      <CareersSection />
      <Footer />
    </>
  );
};

export default ECom;
